import restClient from 'Shared/hooks/restClient'

export default function RequestSoftLogin() {
  useEffect(() => {
    async function fetchData() {
      const { data: { et } } = await restClient.post('/api/users/request_soft_login')

      if (et && window.opener) {
        window.opener.postMessage({ type: 'SOFT_LOGIN_TOKEN', et }, window.ENV.CLIENT_PUBLIC_URL)
      }
    }
    fetchData()
  }, [])

  return <div>Logging in...</div>
}
